<template>
  <div v-if="show" class="preview-bar" @click="show = false">
    Preview Mode
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true
    }
  }
}
</script>

<style lang="scss">
.preview-bar {
  text-align: center;
  width: 100%;
  background: #d67b1b;
  font-weight: 600;
  padding: 0.6rem;
  cursor: pointer;
  margin-bottom: 2rem;
}
</style>
